





























import { AppSteppers, AppSteppersPane } from '@/uikit/components/AppSteppers';
import Button from '@/components/ext/Button.vue';
import DynamicAdditionalDataForm from '@/components/ordersProcessForms/parts/AdditionalDataStep/DynamicAdditionalDataForm.vue';
import FinishMessage from '../parts/finishMessage';
import RequestForm from './components/RequestForm.vue';
import RequestRequirements from '@/components/ordersProcessForms/event/components/RequestRequirements.vue';

export default {
  name: 'EventOrderProcess',
  components: {
    AppSteppersPane,
    DynamicAdditionalDataForm,
    Button,
    AppSteppers,
    RequestForm,
    FinishMessage,
    RequestRequirements,
  },
  data() {
    return {
      finishMsg: {},
      file: undefined,
      answer: undefined,
    };
  },
  methods: {
    requirementsNextStep(
      nextStep: Function,
      answer: string = undefined,
      file: string = undefined
    ) {
      this.answer = answer;
      this.file = file;
      nextStep();
    },
  },
  mounted() {
    console.log(this.$store);
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ordersProcessForms/event/EventOrderProcess.vue